import React from 'react'
import { SiFoursquarecityguide } from 'react-icons/si'
import TabAddTravelGuide from './page-components/TravelGuide/TabAddTravelGuide'
import TabViewTravelGuide from './page-components/TravelGuide/TabViewTravelGuide'
import MasterPageTab from './page-essential/MasterPageTab'

const TravelGuide = () => {
    return (
        <MasterPageTab addBtn='Add Travel Guide Articels' addTab={<TabAddTravelGuide />} viewBtn='View Travel Guides' viewTab={<TabViewTravelGuide />} pageHeading='Travel Guide' pageDescription='Add/modify/delete Travel Guide Articels' icon={<SiFoursquarecityguide />} />
    )
}

export default TravelGuide